module.exports = __webpack_public_path__ + "static/media/294469.24b99a93.png";